import Trix from "trix"
import "@rails/actiontext"

Trix.config.textAttributes.inlineCode = {
  tagName: "code",
  inheritable: true
}

document.addEventListener("trix-initialize", function(event) { })
